import { recalculateSchedule } from './roadmapStore';

export function scheduleAfter(action: () => void) {
  action();
  setTimeout(() => recalculateSchedule(), 0);
}
